import { KuxErrorType, KuxFilteredCategoriesDTO, UIDAPresentationTypeEnum } from '@kaltura-ott/tvpil';
import { computed, when } from 'mobx';

import type { CategoryChildren } from '../../..';
import { RailState } from '../rail-store-v2';

import { RecordAdditionalRailStoreV2 } from './record-rail-additional-store';
import { RecordsStoreV2 } from './record-rail-store-v2';

export class TotalRecordsRailStore extends RecordsStoreV2 {
  subtype: UIDAPresentationTypeEnum.npvr = UIDAPresentationTypeEnum.npvr;
  additionalRail?: RecordAdditionalRailStoreV2;
  groupBy = 'SeriesID';

  constructor(
    categoryTree: KuxFilteredCategoriesDTO,
    parentCategoryTree: KuxFilteredCategoriesDTO,
    children?: CategoryChildren[],
    additionalRail?: RecordAdditionalRailStoreV2,
  ) {
    super(categoryTree, parentCategoryTree, children);
    this.additionalRail = additionalRail;
  }

  async init(): Promise<void> {
    super.init();
    await when(() => this._isReady);
    if (!this.innerItems.length) {
      this.additionalRail?.init();
      await when(() => (this.additionalRail ? this.additionalRail.isReady : true));
    }
  }

  @computed
  public get items() {
    if (this.additionalRail?.items) {
      return [...this.innerItems, ...this.additionalRail.items];
    }
    return this.innerItems;
  }

  @computed
  public get isReady() {
    if (this.innerItems.length <= 0) {
      return !!this.additionalRail?.isReady;
    } else {
      return this._isReady;
    }
  }

  @computed
  public get lastPageWasLoaded() {
    // @ts-expect-error TODO Fix
    return this.isReady && this.additionalRail.isReady && this.additionalRail._lastPageWasLoaded;
  }

  @computed
  public get state() {
    if (this._state === RailState.PENDING || this.additionalRail?.state === RailState.PENDING) {
      return RailState.PENDING;
    }

    if (this._state === RailState.SUCCESS && this.additionalRail?.state === RailState.SUCCESS) {
      return RailState.SUCCESS;
    }

    if (this._state === RailState.ERROR || this.additionalRail?.state === RailState.ERROR) {
      return RailState.ERROR;
    }

    if (this._state === RailState.IDLE || this.additionalRail?.state === RailState.IDLE) {
      return RailState.IDLE;
    }

    return RailState.IDLE;
  }

  get error(): KuxErrorType {
    // @ts-expect-error TODO Fix
    return this._error || this.additionalRail?.error;
  }

  async setVisibleIndex(index: number): Promise<void> {
    if (!this.fullyLoaded) {
      super.setVisibleIndex(index);
    } else {
      if (!this.additionalRail?.isReady) {
        await this.additionalRail?.init();
      }
      const additionalRailIndex = index - this.innerItems.length;
      this.additionalRail?.setVisibleIndex(additionalRailIndex);
    }
  }

  resetStore() {
    super.resetStore();
    this.additionalRail?.resetStore();
  }
}
